export const contactPage = () => `
  <section class="page-content contact-page">
    <div class="container">
      <h1 class="page-title">İletişim</h1>

      <div class="contact-layout">
        <div class="contact-info-section">
          <h2>Herhangi bir sorunuz var mı? Hemen iletişime geçin.</h2>
          <p>Sigorta ihtiyaçlarınız veya mevcut poliçeleriniz hakkında bilgi almak için bize ulaşın. Sizden haber almayı seviyoruz.</p>

          <div class="contact-details">
            <div class="contact-item">
              <strong>Telefon:</strong>
              <a href="tel:+905368949636">0536 894 96 36</a>
            </div>
            <div class="contact-item">
              <strong>E-posta:</strong>
              <a href="mailto:info@yildiz360.com">info@yildiz360.com</a>
            </div>
            <div class="contact-item">
              <strong>Adres:</strong>
              <p>Bahariye Zübeyde Hanım Cad.<br>Karşıyaka No:26/A, İZMİR</p>
            </div>
            <div class="contact-item">
              <strong>Levha No:</strong>
              <p>G08612-F9BY</p>
            </div>
            <div class="contact-item">
              <strong>TP Sicil No:</strong>
              <p>202504450</p>
            </div>
          </div>
        </div>

        <div class="contact-form-section">
          <form class="contact-form">
            <div class="form-row">
              <div class="form-group">
                <input type="text" class="form-control" placeholder="Adınız" required>
              </div>
              <div class="form-group">
                <input type="text" class="form-control" placeholder="Soyadınız" required>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <input type="tel" class="form-control" placeholder="Cep Telefonu" required>
              </div>
              <div class="form-group">
                <input type="email" class="form-control" placeholder="E-Posta" required>
              </div>
            </div>

            <div class="form-group">
              <textarea class="form-control" placeholder="Mesajınız" rows="5" required></textarea>
            </div>

            <div class="form-group">
              <label class="checkbox-label">
                <input type="checkbox" required>
                <span><strong>Kişisel Veriler Bilgilendirme Metni</strong>'ni kabul ediyorum.</span>
              </label>
            </div>

            <div class="form-group">
              <label class="checkbox-label">
                <input type="checkbox">
                <span>SMS, e-posta ve Cep yoluyla elektronik ileti gönderilmesine onay veriyorum.</span>
              </label>
            </div>

            <button type="submit" class="btn-primary">Gönder</button>
          </form>
        </div>
      </div>
    </div>
  </section>
`;
